"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingPriceStatsAttributes$ = exports.ListingPriceStatsAttributes$outboundSchema = exports.ListingPriceStatsAttributes$inboundSchema = void 0;
exports.listingPriceStatsAttributesToJSON = listingPriceStatsAttributesToJSON;
exports.listingPriceStatsAttributesFromJSON = listingPriceStatsAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const listingpricechangewrapper_js_1 = require("./listingpricechangewrapper.js");
/** @internal */
exports.ListingPriceStatsAttributes$inboundSchema = z.object({
    end_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    local_authority_code: z.string(),
    local_authority_name: z.string(),
    start_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    stats: listingpricechangewrapper_js_1.ListingPriceChangeWrapper$inboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "end_date": "endDate",
        "local_authority_code": "localAuthorityCode",
        "local_authority_name": "localAuthorityName",
        "start_date": "startDate",
    });
});
/** @internal */
exports.ListingPriceStatsAttributes$outboundSchema = z.object({
    endDate: z.date().transform(v => v.toISOString()),
    localAuthorityCode: z.string(),
    localAuthorityName: z.string(),
    startDate: z.date().transform(v => v.toISOString()),
    stats: listingpricechangewrapper_js_1.ListingPriceChangeWrapper$outboundSchema,
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        endDate: "end_date",
        localAuthorityCode: "local_authority_code",
        localAuthorityName: "local_authority_name",
        startDate: "start_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ListingPriceStatsAttributes$;
(function (ListingPriceStatsAttributes$) {
    /** @deprecated use `ListingPriceStatsAttributes$inboundSchema` instead. */
    ListingPriceStatsAttributes$.inboundSchema = exports.ListingPriceStatsAttributes$inboundSchema;
    /** @deprecated use `ListingPriceStatsAttributes$outboundSchema` instead. */
    ListingPriceStatsAttributes$.outboundSchema = exports.ListingPriceStatsAttributes$outboundSchema;
})(ListingPriceStatsAttributes$ || (exports.ListingPriceStatsAttributes$ = ListingPriceStatsAttributes$ = {}));
function listingPriceStatsAttributesToJSON(listingPriceStatsAttributes) {
    return JSON.stringify(exports.ListingPriceStatsAttributes$outboundSchema.parse(listingPriceStatsAttributes));
}
function listingPriceStatsAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ListingPriceStatsAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ListingPriceStatsAttributes' from JSON`);
}
//# sourceMappingURL=listingpricestatsattributes.js.map